<template>
  <div id="side-bar" ref="sidebar" class="c-sidebar" :class="{'little': isClose}">
    <div class="logo-wrap" :class="{'mini': isClose}">
      <img :src="!isClose ? imgLogo : imgLogoMini" alt="">
    </div>
    <div class="links">
      <span v-for="(link, index) in links" :key="index" class="link-wrapper">
        <n-link
          v-show="isShow(link.permissions, link.condition)"
          class="link" :to="!!link.child ? '': {name: link.name}"
          :class="{'active': isActive(link.name), 'withChild': link.child?.length > 0}"
          @click="link.child?.length > 0 ? openLink(link.name) : ''">
          <div class="mark"></div>
          <div class="title-wrap">
            <div class="image-place">
              <img v-if="isActive(link.name)" :src="link.iconActive" alt="">
              <img v-else :src="link.icon" alt="">
            </div>
            <div v-if="!isClose" class="title">{{ link.title }}</div>
            <div v-if="link.child?.length > 0" class="image-place child-row">
              <img :src="isActive(link.name) ? childRowActive : childRow" alt="">
            </div>
          </div>
        </n-link>
        <span v-show="link.child?.length > 0 && openedLink === link.name" class="sub-link-wrapper">
          <n-link
            v-for="(child, i) in link.child"
            v-show="isShow(child.permissions, child.condition) "
            :key="i"
            class="link" :to="{name: child.name}"
            :class="{'active': isActive(child.name)}">
            <div class="mark"></div>
            <div class="title-wrap">
              <div class="image-place">
                <img v-if="isActive(child.name)" :src="child.iconActive" alt="">
                <img v-else :src="child.icon" alt="">
              </div>
              <div v-if="!isClose" class="title">{{ child.title }}</div>
            </div>
          </n-link>
        </span>
      </span>
    </div>
    <div class="image-close" :class="{'closed': isClose}">
      <img :src="imgClose" alt="" @click="isClose = !isClose" />
    </div>
  </div>
</template>

<script>
import imgLogo from 'assets/logo-icon.svg'
import imgLogoMini from 'assets/mini-logo-icon.png'
import imgBranches from 'assets/sidebar-icons/branches-icon.svg'
import imgBranchesActive from 'assets/sidebar-icons/branches-icon-active.svg'
import imgClose from '../../assets/sidebar-icons/close-sidebar-icon.svg'
import imgEmployees from '../../assets/sidebar-icons/employees-icon.svg'
import imgEmployeesActive from '../../assets/sidebar-icons/employees-icon-active.svg'
import imgPositions from '../../assets/sidebar-icons/positions-icon.svg'
import imgPositionsActive from '../../assets/sidebar-icons/positions-icon-active.svg'
import imgFinance from '../../assets/sidebar-icons/finance-icon.svg'
import imgFinanceActive from '../../assets/sidebar-icons/finance-icon-active.svg'

import childRow from 'assets/sidebar-icons/with-child-row.svg'
import childRowActive from 'assets/sidebar-icons/with-child-row-active.svg'


export default {
  name: 'CSidebar',
  data() {
    return {
      links: [
        {
          name: 'companies',
          permissions: [ 'companies_getList', ],
          title: 'Компании',
          icon: imgBranches,
          iconActive: imgBranchesActive,
        },
        {
          name: 'users',
          permissions: [ 'users_get', ],
          title: 'Сотрудники',
          icon: imgEmployees,
          iconActive: imgEmployeesActive,
        },
        {
          name: 'positions',
          permissions: [ 'roles_create', ],
          title: 'Роли',
          icon: imgPositions,
          iconActive: imgPositionsActive,
        },
        {
          name: 'kdo',
          permissions: [ 'companies_getList', ],
          title: 'КЭДО',
          icon: imgPositions,
          iconActive: imgPositionsActive,
        },
        {
          name: 'tariffs',
          permissions: [ '', ],
          title: 'Тарифы',
          icon: imgFinance,
          iconActive: imgFinanceActive,
        },
        // {
        //   name: 'financial',
        //   permissions: [ 'salaries_get', ],
        //   title: 'Финансы',
        //   icon: imgFinance,
        //   iconActive: imgFinanceActive,
        //   child: [
        //     {
        //       name: 'finances',
        //       permissions: [ 'salaries_get', ],
        //       title: 'Расчет зарплаты',
        //       icon: imgFinanceStats,
        //       iconActive: imgFinanceStatsActive,
        //     },
        //     {
        //       name: 'finesRewards',
        //       permissions: [ 'salaries_get', ],
        //       title: 'Штрафы и награды',
        //       icon: imgFines,
        //       iconActive: imgFinesActive,
        //     },
        //   ],
        // },
      ],
      imgLogoMini,
      imgClose,
      childRow,
      childRowActive,
      open: false,
      isClose: false,
      user: {},
      imgLogo,
      showOrganization: false,
      openedLink: '',
    }
  },
  computed: {
    route() {
      return this.$route.name
    },
  },
  watch: {
    isClose() {
      this.$emit('update:isSlide', this.isClose)
    },
  },
  created() {
  },
  methods: {
    isShow(permissions, other) {
      let show = true
      if (permissions) {
        show = false
        $n.each(permissions, (e) => {
          if (!show) {
            show = $app.auth.can(e)
          }
        })
      }
      if (other) {
        show = other
      }
      return show
    },
    openLink(name) {
      if (this.openedLink === name) {
        this.openedLink = ''
      } else {
        this.openedLink = name
      }
    },
    isActive(name) {
      if (name === 'companies') {
        return [ 'companies', 'add-company', 'company', ].includes(this.route)
      }
      if (name === 'users') {
        return [ 'users', 'add-user', 'user', ].includes(this.route)
      }
      if (name === 'positions') {
        return [ 'positions', 'add-position', ].includes(this.route)
      }
      if (name === 'kdo') {
        return [ 'kdo', 'kdo-company', 'kdo-help', ].includes(this.route)
      }
      if (name === 'tariffs') {
        return [ 'tariffs', 'add-tariff', 'tariff', ].includes(this.route)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.c-sidebar {
  width: 270px;
  padding: 0 20px 20px 0;
  transition: 0.3s;
  height: 100dvh;
  display: flex;
  align-items: center;
  flex-direction: column;
  position: sticky;
  top: 0;

  .links {
    overflow: auto;
  }

  @media (-webkit-device-pixel-ratio: 1.25) and (max-height: 870px) {
    height: calc(100dvh * 0.95);
    zoom: 70%;
    .links {
      overflow: unset;
    }
  }
  @media (-webkit-device-pixel-ratio: 2) and (max-height: 1440px) {
    zoom: 90%;
    .links {
      overflow: unset;
    }
  }

  @media (width: 1920px) and (-webkit-device-pixel-ratio: 1) {
    zoom: 90%;
    .links {
      overflow: unset;
    }
  }
  @media (max-width: 1380px) {
    height: auto;
  }

  .logo-wrap {
    width: 220px;
    height: 110px;
    transition: 0.3s;

    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }

  &.little {
    width: 90px;
    padding: 0 0 50px 0;
    transition: 0.3s;

    .link {
      width: 90px;
      transition: 0.5s;

      &.active {
        .image-place {
          margin-left: 5px;
        }
      }
    }

    .logo-wrap {
      width: 100%;
      transition: 0.3s;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-left: 5px;

      img {
        width: 60px;
        height: 60px;
        object-fit: contain;
      }
    }
  }

  .link {
    display: flex;
    align-items: center;
    height: 60px;
    flex-shrink: 0;
    width: 250px;

    .mark {
      width: 6px;
      height: 100%;
      background: #fff;
      border-radius: 0 10px 10px 0;
    }

    .title-wrap {
      display: flex;
      align-items: center;
      margin-left: 30px;

      .image-place {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        min-width: 24px;
        min-height: 24px;
        max-width: 28px;
        max-height: 28px;
        transition: 1s;

        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
        &.child-row {
          min-width: 18px;
          min-height: 18px;
          margin-left: 10px;
        }
      }

      .title {
        color: #B1B1B1;
        font-size: 17px;
        font-weight: 500;
        margin-left: 15px;
      }
    }

    &.active {

      .image-place {
        margin-left: 10px;
      }

      .mark {
        background: var(--primary);
      }

      .title {
        color: var(--primary);
      }
    }
    &.withChild {
      .image-place {
        margin-left: 0;
      }
    }

  }

  .image-close {
    display: flex;
    align-items: center;
    width: 100%;
    justify-content: center;
    transition: 0.5s;
    margin-left: 10px;
    margin-top: 10px;

    &.closed {
      transform: rotate(180deg);
      transition: 0.5s;
    }
  }


  .sub-link-wrapper {
    .link {
      .title-wrap {
        margin-left: 45px;
      }
    }
  }
}
</style>
